import * as type from './constants';

export const setIsLoading = isLoading => ({
  type: type.SET_IS_LOADING,
  isLoading
});

export const setSchedulingServices = data => ({
  type: type.SET_SCHEDULING_SERVICES,
  data
});

export const clearSchedulingServices = () => ({
  type: type.CLEAR_SCHEDULING_SERVICES
});